import React, { Component } from 'react';
import { connect } from 'react-redux';
import Xarrow from "react-xarrows";
import {
  Image,
  Menu,
  Sidebar,
  Accordion,
  Search,
  Loader,
  Header,
  Grid,
  Divider,
  Icon,
  Button,
} from 'semantic-ui-react';
import {
  FETCH_START_SUGGESTIONS,
  FETCH_DESTINATION_SUGGESTIONS,
  SET_START,
  SET_DESTINATION,
  CLEAN_START,
  CLEAN_DESTINATION,
  FINISH_START_SEARCH,
  FINISH_DESTINATION_SEARCH,
  START_START_SEARCH,
  START_DESTINATION_SEARCH,
  SET_SIDEBAR_VISIBILITY
} from '../actions/types';
import {
  fetchLocation,
  fetchRoute,
  fetchSuggestions,
  setLocation,
  selectRoute,
  finishSearch,
  cleanQuery,
  startLocationSearch,
  swapLocations,
  setSidebarVisibility
} from '../actions/interactionActions';
import Itinerary from './Itinerary';
import TimeOfDeparturePicker from './TimeOfDeparturePicker';
import start from '../images/routingMenu/start.svg';
import destination from '../images/routingMenu/destination.svg';
import hamburger from '../images/routingMenu/hamburger.svg';
import swap from '../images/routingMenu/swap.svg';

/**
 * Component responsible for user input; the map component will react accordingly
 * Props:
 *    start:        user query for their point of origin, needed for Here Maps API call
 *    destination:  user query for their destination point, needed for Here Maps API call
 */
class RoutingMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start: '',
      destination: '',
      loader: false,
    };
  }

  timeoutRef = React.createRef();

  handleStartSearch = (e, data) => {
    clearTimeout(this.timeoutRef.current);
    this.props.startLocationSearch(data.value, START_START_SEARCH);
    this.props.fetchSuggestions(data.value, FETCH_START_SUGGESTIONS);

    this.timeoutRef.current = setTimeout(() => {
      if (data.value.length === 0) {
        this.props.cleanQuery(CLEAN_START);
        return;
      }

      this.props.finishSearch(this.props.startSuggestions, FINISH_START_SEARCH);
    }, 300)
  };

  handleDestinationSearch = (e, data) => {
    clearTimeout(this.timeoutRef.current);
    this.props.startLocationSearch(data.value, START_DESTINATION_SEARCH);
    this.props.fetchSuggestions(data.value, FETCH_DESTINATION_SUGGESTIONS);

    this.timeoutRef.current = setTimeout(() => {
      if (data.value.length === 0) {
        this.props.cleanQuery(CLEAN_DESTINATION);
        return;
      }

      this.props.finishSearch(this.props.destinationSuggestions, FINISH_DESTINATION_SEARCH);
    }, 300)
  };

  handleStartSelect = (e, data) => {
    this.props.setLocation(data.result, SET_START);
    try {
      this.props.fetchRoute(data.result.coordinates, this.props.destinationCoordinates, this.props.dateTime);
    } catch (error) {
      console.log(error);
    }
  };

  handleDestinationSelect = (e, data) => {
    this.props.setLocation(data.result, SET_DESTINATION);
    try {
      this.props.fetchRoute(this.props.startCoordinates, data.result.coordinates, this.props.dateTime);
    } catch (error) {
      console.log(error);
    }
  };

  componentDidMount = () => {
    return () => {
      clearTimeout(this.timeoutRef.current);
    }
  }

  handleSwap = () => {
    if (this.props.selectedStart !== '' && this.props.selectedDestination !== '') {
      this.props.fetchRoute(this.props.destinationCoordinates, this.props.startCoordinates, this.props.dateTime);
    }

    this.props.swapLocations(this.props.selectedStart, this.props.selectedDestination);
  }

  getStartSearchIcon = () => {
    if(this.props.startValue === '') {
      return <Icon name=' ' />
    } else {
      return <Icon name='close' link onClick={() => {
        this.props.cleanQuery(CLEAN_START);
      }} />
    }
  }

  getDestinationSearchIcon = () => {
    if(this.props.destinationValue === '') {
      return <Icon name=' ' />
    } else {
      return <Icon name='close' link onClick={() => {
        this.props.cleanQuery(CLEAN_DESTINATION);
      }} />
    }
  }

  render() {
    return (
      <Sidebar /*basically the whole sidebar; props are used for appearance and animation*/
        as={Menu}
        animation={'overlay'}
        direction={'left'}
        icon='labeled'
        vertical
        visible={this.props.visible}
        style={{width: '360px'}}
      >
        <br />
        <Grid verticalAlign='middle'>
          <Grid.Row style={{ paddingTop: '2rem', paddingBottom: 0 }}>
            <Grid.Column width={3}>
              <Image className='pointOnHover' onClick={() => { this.props.setSidebarVisibility(SET_SIDEBAR_VISIBILITY) }} src={hamburger} spaced='left'/>
            </Grid.Column>
            <Grid.Column width={10}>
              <Header as='h2'>Reiseauskunft</Header>
            </Grid.Column>
            <Grid.Column width={3} id='sidebar-close-btn-container'>
              {this.props.visible ? <Button id='sidebar-close-btn' onClick={() => { this.props.setSidebarVisibility(SET_SIDEBAR_VISIBILITY) }}>
                <Icon name='left chevron' id='sidebar-clost-btn-icon' />
              </Button> : null}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row style={{ paddingBottom: '0px' }}>
            <Grid.Column>
              <Image id='startSearchIcon' src={start} width='24px' style={{ position: 'absolute', marginTop: '8px', marginLeft: '14px', zIndex: 1 }} />
              <Search
                id='startSearch'
                placeholder='Startort wählen'
                onFocus={e => e.target.select()}
                selectFirstResult
                loading={this.props.startLoading}
                onResultSelect={this.handleStartSelect}
                onSearchChange={this.handleStartSearch}
                results={this.props.startResults}
                value={this.props.startValue}
                icon={this.getStartSearchIcon}
                fluid
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingBottom: '0px', paddingTop: '0px' }}>
            <Grid.Column width={12} />
            <Grid.Column width={4}>
              <Image src={swap} onClick={this.handleSwap} style={{ paddingLeft: '20px', cursor: 'pointer' }} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingBottom: '0px', paddingTop: '0px' }}>
            <Grid.Column>
              <Image id='destinationSearchIcon' src={destination} width='22px' style={{ position: 'absolute', marginTop: '7px', marginLeft: '15px', zIndex: 1 }} />
              <Search
                id='destinationSearch'
                placeholder='Zielort wählen'
                onFocus={e => e.target.select()}
                selectFirstResult
                loading={this.props.destinationLoading}
                onResultSelect={this.handleDestinationSelect}
                onSearchChange={this.handleDestinationSearch}
                results={this.props.destinationResults}
                value={this.props.destinationValue}
                icon={this.getDestinationSearchIcon}
                fluid
              >
              </Search>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingBottom: '0px', paddingTop: '0px' }}>
            <Grid.Column width={12} />
            <Grid.Column width={4}>
              <Icon size='large' />
            </Grid.Column>
          </Grid.Row>
          <TimeOfDeparturePicker />
        </Grid>
        <Xarrow start='startSearchIcon' end='destinationSearchIcon' startAnchor='middle' endAnchor='top' color='#656565' headSize={0} dashness={{strokeLen: 4, nonStrokeLen: 8}}/>
        <br />

        {/*startRenderRoutes()*/}

        <Divider style={{marginTop: '2rem', marginBottom: '1rem'}}/>

        {
          //  ugly way of spacing the loader
          this.props.hideGuide && this.props.isLoading === 1 &&
          <>
            <br /><br /><br />
            <Loader active={this.props.hideGuide && this.props.isLoading === 1} inline>
              <Header as='h3' style={{paddingTop: '1rem' }}>Suche läuft...</Header>
            </Loader>
          </>
        }
        <Accordion
          /**
           * Dropdowns for the different routes based on the query results
           * Props:
           *  fluid:  styling purposes (SemanticUI)
           *  styled: styling purposes (SemanticUI)
           *  hidden: dropdowns will not be displayed if user is changing route request or hasn't requested one yet
           * 
           * Props of children:
           *  active: related to the active dropdown; other dropdowns are deactivated
           * 
           * TODO:  Public transit route has to be integrated here as well
           */
          fluid
          hidden={this.props.hideGuide}
        >
          {this.props.times.length >= 1 && <Itinerary index={0} />}
          {this.props.times.length >= 2 && <Itinerary index={1} />}
          {this.props.times.length >= 3 && <Itinerary index={2} />}
          {this.props.times.length >= 4 && <Itinerary index={3} />}
          {this.props.times.length >= 5 && <Itinerary index={4} />}
          {this.props.times.length >= 6 && <Itinerary index={5} />}
        </Accordion>
      </Sidebar>
    );
  };
}

const mapStateToProps = state => ({
  // sidebar visibility
  visible: state.posts.sideBarVisible,

  // loading status
  isLoading: state.posts.isLoading,

  startCoordinates: state.posts.startCoordinates,
  destinationCoordinates: state.posts.destinationCoordinates,
  startSuggestions: state.posts.startSuggestions,
  destinationSuggestions: state.posts.destinationSuggestions,

  //  query results, up to 6 different routes
  route: state.posts.route,

  //  duration of every route
  times: state.posts.times,
  departureTimes: state.posts.departureTimes,
  parkingTimes: state.posts.parkingTimes,
  arrivalTimes: state.posts.arrivalTimes,
  parkingLotNames: state.posts.parkingLotNames,
  hideGuide: state.posts.hideGuide,

  //  currently selected route/dropdown
  selectedRoute: state.posts.selectedRoute,
  startLoading: state.posts.startLoading,
  startResults: state.posts.startResults,
  startValue: state.posts.startValue,
  destinationLoading: state.posts.destinationLoading,
  destinationResults: state.posts.destinationResults,
  destinationValue: state.posts.destinationValue,

  dateTime: state.posts.dateTime,
  selectedStart: state.posts.selectedStart,
  selectedDestination: state.posts.selectedDestination,
});

export default connect(
  mapStateToProps,
  {
    setSidebarVisibility,
    fetchLocation,
    fetchRoute,
    fetchSuggestions,
    setLocation,
    selectRoute,
    finishSearch,
    cleanQuery,
    startLocationSearch,
    swapLocations
  }
)(RoutingMenu);
